import { render, staticRenderFns } from "./UpdateBookingSlot.vue?vue&type=template&id=22cd3d14&scoped=true&"
import script from "./UpdateBookingSlot.vue?vue&type=script&lang=js&"
export * from "./UpdateBookingSlot.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBookingSlot.vue?vue&type=style&index=0&id=22cd3d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd3d14",
  null
  
)

export default component.exports